export const NavyogaLogo = ({ className = "h-11", flat = false }) => (
  <img
    src="/assets/navyoga-logo.jpg"
    alt="NAVYOGA — Yoga and Wellness Center"
    data-testid="navyoga-logo-image"
    className={`${className} w-auto rounded-md bg-white object-contain ${
      flat ? "" : "shadow-sm ring-1 ring-emerald-900/10"
    }`}
  />
);

export const LeafMotif = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 2C7.2 6.8 4.5 10.8 4.5 14.5a7.5 7.5 0 0 0 15 0C19.5 10.8 16.8 6.8 12 2Z"
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <path d="M12 6.5v13M12 12c-1.8-.6-3-1.8-3.6-3.6M12 14.5c1.8-.6 3-1.8 3.6-3.6" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" />
  </svg>
);
